import React from 'react';

interface TableRowProps {
  isActive?: boolean,
  isDisabled?: boolean,
  fn?: (a?: any) => void,
  label: string,
}

const Tab: React.FC<TableRowProps> = ({ isActive = true, isDisabled = false, fn = () => null, label }) => {
  return (
    <button 
      className={`
        font-sans font-medium tracking-tight
        px-4 py-2 mx-2 border-b-2
        ${isActive ? 'border-pink-200' : 'border-transparent'}
        ${!isDisabled ? 'hover:bg-slate-100 hover:text-pink-200' : 'cursor-not-allowed opacity-50'}
        rounded-t-md transition
      `}
      onClick={fn}
      disabled={isDisabled}
    >
      { label }
    </button>
  );
};

export default Tab;
